import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { notify } from "@/lib/notify";
import { cn } from "@/lib/cn";
import { Megaphone, X } from "lucide-react";

const DISMISS_KEY = "arkiveai.ann.dismissed";
const NOTIFIED_KEY = "arkiveai.ann.notified";

export default function AnnouncementBanner() {
  const { data } = useQuery({
    queryKey: ["announcement"],
    queryFn: api.announcement,
    staleTime: 5 * 60 * 1000,
    refetchInterval: 10 * 60 * 1000,
  });
  const ann = data?.announcement ?? null;
  const [dismissed, setDismissed] = useState<number | null>(() => {
    const v = localStorage.getItem(DISMISS_KEY);
    return v ? Number(v) : null;
  });

  // 새 공지(id 변경)면 브라우저 알림(권한 있을 때)
  useEffect(() => {
    if (!ann) return;
    if (Number(localStorage.getItem(NOTIFIED_KEY)) !== ann.id) {
      notify("ArkiveAI 공지", ann.message);
      localStorage.setItem(NOTIFIED_KEY, String(ann.id));
    }
  }, [ann?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!ann || dismissed === ann.id) return null;
  const warn = ann.level === "warn";
  return (
    <div
      className={cn(
        "flex items-start gap-2 px-3 py-2 text-sm",
        warn ? "bg-[#0E1E2D] text-white" : "bg-primary/10 text-foreground",
      )}
    >
      <Megaphone className="mt-0.5 h-4 w-4 shrink-0" />
      <span className="min-w-0 flex-1 whitespace-pre-wrap break-words">{ann.message}</span>
      <button
        onClick={() => {
          setDismissed(ann.id);
          localStorage.setItem(DISMISS_KEY, String(ann.id));
        }}
        aria-label="공지 닫기"
        className="shrink-0 opacity-80 hover:opacity-100"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
